module.exports = __webpack_public_path__ + "static/img/banner3ls.83a8585.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/banner3ls.jpg
// module id = 48JZ
// module chunks = 0